import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {getListEventsParticipants,getFilterEventsList,getAssociationEventsDocument,getLisDocument} from '../../actions/eventsActions';
import {Container} from 'reactstrap';
import config from "../../utils/config.json"
import { Link } from 'react-router-dom';


class EventDownloadUser extends Component {
  componentDidMount() {
    let {getListEventsParticipants,getFilterEventsList, limit} = this.props
    let {getAssociationEventsDocument,getLisDocument} = this.props
    
    getListEventsParticipants();
    getFilterEventsList(limit);

    getAssociationEventsDocument();
    getLisDocument();
  }

  render() {
    let {fetching, data} = this.props.events;
    let {fetchingdw, datadw} = this.props.eventsdownload;
    let {datassoc} = this.props.eventsassoc;
    let {datadoc, fetchingdoc} = this.props.eventsdocument;
    console.log("------assoc--------")
    console.log(datassoc)
    console.log("-------doc-------")
    console.log(datadoc)
    console.log("------participant--------")
    console.log(datadw)
    let {login} = this.props.userState;
    // console.log("--------------")
    // console.log(login)

   return (
        <div>
          <Container className="page-download">
            <h2 className="my-4 text-center">Téléchargement de documents</h2>
            <table className="table">
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Titre</th>
                  <th>Activé</th>
                  <th>Télécharger de document</th>
                </tr>
              </thead>
              <tbody>
                {fetchingdw ? (
                  <tr>
                    <td colSpan="4">Aucun document</td>
                  </tr>
                ) : (
                  datadw && datadw.map((itemdw, keydw) => {
                    if (login.isLogin && parseInt(login.data.id, 10) === parseInt(itemdw.id_customer, 10)) {
                     
                      return [
                        <tr key={keydw}>
                          <td>{itemdw.active === '1' || itemdw.active === 1 ? <p>{itemdw.name}</p> : null}</td>
                          <td>
                            {fetching ? (
                              <div></div>
                            ) : (
                              <div>
                                {(itemdw.active === '1' || itemdw.active === 1) &&
                                  data &&
                                  data.map((item, key) => (
                                    <div key={key}>
                                      {parseInt(item.id, 10) === parseInt(itemdw.id_events, 10) ? (
                                        <p>{item.title}</p>
                                      ) : null}
                                    </div>
                                  ))}
                              </div>
                            )}
                          </td>
                          <td>{itemdw.active === '1' || itemdw.active === 1 ? <p>{itemdw.active}</p> : null}</td>
                          <td>
                          {data && data.map((item, key) => (
                            <div key={key}>
                              {parseInt(item.id, 10) === parseInt(itemdw.id_events, 10) ? (
                                <div>
                                  {!fetchingdoc && (
                                    <div>
                                      {datassoc && datassoc.map((itemassoc, keyassoc) => (
                                        <div key={keyassoc}>
                                          {itemassoc.id_events === itemdw.id_events && (
                                            <div>
                                              {datadoc && datadoc.map((itemdoc, keydoc) => (
                                                <span key={keydoc}>
                                                  {parseInt(itemdoc.id, 10) === parseInt(itemassoc.id_events_download, 10) && (
                                                    <a
                                                      href={`${config.shopUrl}modules/formation/uploads/${itemdoc.document}`}
                                                      download={itemdoc.document} title="télécharger"
                                                    >
                                                      {itemdoc.name}
                                                    </a>
                                                  )}
                                                </span>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                      {(!datassoc || datassoc.filter(itemassoc => itemassoc.id_events === itemdw.id_events).length === 0) && (
                                        <div>Aucun document</div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          ))}
                        </td>
                        </tr>,
                      ];
                    }
                    return null;
                  })
                )}
              </tbody>
            </table>
            <Link to="/user" className="ml-2 btn btn-primary">
                Retour
            </Link>
          </Container>
        </div>
      );




    
  }
}

function mapStateToProps({eventsReducer,userReducer}) {
  return {
    eventsdocument: eventsReducer.document,
    eventsdownload: eventsReducer.download,
    eventsassoc: eventsReducer.assoc,
    events: eventsReducer,
    userState: userReducer,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getListEventsParticipants: bindActionCreators(getListEventsParticipants, dispatch),
    getFilterEventsList: bindActionCreators(getFilterEventsList, dispatch),
    getAssociationEventsDocument: bindActionCreators(getAssociationEventsDocument, dispatch),
    getLisDocument: bindActionCreators(getLisDocument, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDownloadUser);



// WEBPACK FOOTER //
// ./src/components/events/EventDownloadUser.js